module.exports = __webpack_public_path__ + "static/media/card3.0a6f413d.webp";